var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#whatsapp';
                    var viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#view-whatsapp';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?whatsapp#whatsapp';
                            viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?whatsapp#view-whatsapp';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 360 362',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };